import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import Panel from "../Panel/Panel";

export function FeedsFallback(props) {
  return (
    <Panel classList="panel--info alert alert-info">
      <span><FontAwesomeIcon icon={solid("info-circle")} /> There are no updates at this time. </span>
    </Panel>
  )
}

export default FeedsFallback;